import * as z from 'zod';

import { AuthorizedContactId, BorrowerId, CompanyId, EntityId, LoanOwnerId, LosId, PoolId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';
import { ExportableAddress } from '../util/ExportableAddress';

export const ExportableLoan = z
  .object({
    id: LosId,
    company: CompanyId,
    address: ExportableAddress,
    // configuration: LoanConfiguration; // TODO
    originalAmount: z.number(),
    // raw: object; // TODO
    poolId: PoolId.optional(),
    previousServicerId: z.string().optional(),
    capitalPartnerId: z.string().optional(),
    fullId: z.string().optional(),
    otherId1: z.string().optional(),
    otherId2: z.string().optional(),
    otherId3: z.string().optional(),
    ownerId: LoanOwnerId.optional(),
    noteflowId: z.string().optional(),
    primaryBorrower: BorrowerId,
    additionalBorrowers: BorrowerId.array(),
    entityId: EntityId.optional(),
    authorizedContacts: AuthorizedContactId.array(),
    // externalIdHistory: { // TODO
    //   poolId: ExternalIdHistory[];
    //   previousServicerId: ExternalIdHistory[];
    //   capitalPartnerId: ExternalIdHistory[];
    //   fullId: ExternalIdHistory[];
    //   otherId1: ExternalIdHistory[];
    //   otherId2: ExternalIdHistory[];
    //   otherId3: ExternalIdHistory[];
    //   ownerId: ExternalIdHistory[];
    // };
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
    archivedAt: zodTemporalInstant.optional(),
  })
  .meta({ title: 'Loan' });

export type ExportableLoan = z.infer<typeof ExportableLoan>;
